import { useRef, useCallback } from 'react';

export function useDashboardScroll() {
  const sectionRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});

  const scrollToSection = useCallback((sectionKey: string) => {
    requestAnimationFrame(() => {
      setTimeout(() => {
        const sectionElement = sectionRefs.current[sectionKey];
        if (sectionElement) {
          const rect = sectionElement.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const targetScrollTop =
            scrollTop + rect.top - window.innerHeight / 2 + rect.height / 2;

          window.scrollTo({
            top: targetScrollTop,
            behavior: 'smooth',
          });
        }
      }, 200);
    });
  }, []);

  return { sectionRefs, scrollToSection };
}
